import { BaseModel } from '../../../shared/base/base.models';
import { PointOfSale } from '../points-of-sale/points-of-sale.models';
import { OfferedProduct } from '../offered-products/offered-products.models';
import { BusinessPartner } from '../business-partners/business-partners.models';

export class ProductCatalogue extends BaseModel {
    pointOfSale?: PointOfSale | string;
    code?: string;
    businessPartner?: BusinessPartner | string;
    validFrom?: Date | string;
    validTo?: Date | string;
    status?: ProductCatalogueStatus | string;
    items?: ProductCatalogueItem[] = [];
    // helper fields
    itemStatus?: string;

    constructor() {
        super();
        let date = new Date();
        let year = date.getFullYear();
        let dt = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
        let month = (date.getMonth()+1) < 10 ? '0'+(date.getMonth()+1) : (date.getMonth()+1);
        this.validFrom = year+'-' + month + '-'+dt+'T00:00:00.000';
        this.validTo = year+'-' + month + '-'+dt+'T23:59:59.000';
    }
}

export class ProductCatalogueItem extends BaseModel {
    offeredProduct?: OfferedProduct | string;
    amountFrom?: number = 0;
    amountTo?: number = 0;
    discountPercentage1?: number = 0;
    discountPercentage2?: number = 0;
    discountPercentage3?: number = 0;
    active?: boolean = true;
    // helper fields
    discountPrice1?: number | string = 0;
    discountPrice3?: number | string = 0;
    discountPrice2?: number | string = 0;
    productCatalogue?: string;
}

export class AttributeSelection {
    productCatalogue?: string;
    productAttributes?: string[] = [];
    productAttributeType?: string;
    pointOfSale?: string;
    amountFrom?: number;
    discountPercentage1?: number;
    discountPercentage2?: number;
    discountPercentage3?: number;
    updateExisting?: boolean = false;
}

export class ProductCatalogueHelper {
    catalogue: string | number;
    items: string[] = [];

    constructor(catalogue:string | number, items:ProductCatalogueItem[]) {
        this.catalogue = catalogue;
        this.items = items.map((pci) => pci.id)
    }
}

export enum ProductCatalogueStatus {
    DRAFT, ACTIVE, DEACTIVATED
}

export enum ProductAttributeType {
    ASSORTMENT, BRAND, CATEGORY, GROUP, MERCHANDISE_GROUP
}

export enum CopyType {
    ALL, ACTIVE, INACTIVE, SELECTED
}